
import { Options, Vue } from "vue-class-component";
import Summary from "./components/summary.vue";
import { OptionsClass } from "@/domain/entities/MainApp";
import CategoryLeaderboardFilter from "./components/category-leaderboard-filter.vue";
import { PosLeaderboard } from "@/domain/entities/PosLeaderboard";
import LpButton from "@/app/ui/components/lp-button/index.vue";
import PopupTopCustomer from "./components/popup-top-customer.vue";
import PosLeaderboardTable from "./components/table/index.vue";
import { PosLeaderboardCofig } from "@/domain/entities/PosLeaderboard";
import { POSLeaderboardController } from "@/app/ui/controllers/POSLeaderboardController";
import { SummaryApiRequest } from "@/data/payload/api/PosLeaderboard";
import {
  parsingErrorResponse,
  formatDate
} from "@/app/infrastructures/misc/Utils";

@Options({
  components: {
    Summary,
    CategoryLeaderboardFilter,
    LpButton,
    PopupTopCustomer,
    PosLeaderboardTable
  }
})
class PosLeaderboardComponent extends Vue {
  period = "";
  config: PosLeaderboardCofig[] = [];
  error = "";

  getFilter(filter: OptionsClass) {
    if (this.categoryOptions.length) {
      this.category = this.categoryOptions[0];
    }

    this.period = filter.value;

    this.getSummary();
    this.getConfig();
  }
  onRetry() {
    this.getSummary();
    this.getConfig();
  }

  summaryData = new PosLeaderboard();
  loadingSummary = true;

  async getSummary() {
    this.summaryData = new PosLeaderboard();

    if (!this.period) return;

    try {
      this.loadingSummary = true;

      this.summaryData = await POSLeaderboardController.getSummary(
        new SummaryApiRequest({
          period: this.period
        })
      );
    } catch (error) {
      this.summaryData = new PosLeaderboard({
        isNoData: Boolean(parsingErrorResponse(error).type)
      });
    } finally {
      this.loadingSummary = false;
    }
  }

  category = new OptionsClass();

  get categoryOptions() {
    const { national, area, newPos } = this.summaryData.cards;

    const options: OptionsClass[] = [];

    if (national.rank) {
      options.push(
        new OptionsClass({
          label: this.$t("dashboard.leaderboard.national"),
          value: "NATIONAL"
        })
      );
    }

    if (area?.rank) {
      options.push(
        new OptionsClass({
          label: area.rankTitle,
          value: "AREA"
        })
      );
    }

    if (newPos?.rank) {
      options.push(
        new OptionsClass({
          label: this.$t("dashboard.leaderboard.newPos"),
          value: "NEW_POS"
        })
      );
    }

    return options;
  }

  async getConfig() {
    this.error = "";

    if (!this.period) return;

    try {
      const resp = await POSLeaderboardController.getConfig(
        new SummaryApiRequest({
          period: this.period,
          scope: this.category.value
        })
      );
      this.config = resp;
    } catch (error) {
      this.error = parsingErrorResponse(error).type;
    }
  }

  formatDateToString(date: string) {
    return formatDate(date, "DD MMM YYYY, HH:mm");
  }

  mounted() {
    this.category = new OptionsClass({
      label: this.$t("dashboard.leaderboard.national"),
      value: "NATIONAL"
    });
  }
}

export default PosLeaderboardComponent;
